import { useState } from 'react'
import zapierApi from '@/infrastructure/api/zapier'
import processesApi from '@/infrastructure/api/processes'

interface ReportIncidentRequest {
  group: string
  ecommerce: string
  user: string
  processId: string
  incidentType: 'rever' | 'logistics'
  issueTitle: string
  translatedIssueTitle: string
  incidentDescription: string
  language?: string
  invoice?: File
  photos: File[]
}

export function useReportIncident() {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(false)
  const [success, setSuccess] = useState(false)

  const reportIncidentRequest = async (params: ReportIncidentRequest) => {
    setIsLoading(true)
    setError(false)
    setSuccess(false)
    try {
      const [invoiceUrl, ...photoUrls] = params.invoice
        ? await processesApi.uploadIncidentDocuments(params.processId, [
            params.invoice,
            ...params.photos
          ])
        : []
      await zapierApi.sendIncidentReport(
        params.group,
        params.ecommerce,
        params.user,
        params.processId,
        params.incidentType,
        params.issueTitle,
        params.translatedIssueTitle,
        params.incidentDescription,
        params.language,
        invoiceUrl,
        photoUrls
      )
      setSuccess(true)
    } catch (err) {
      console.warn(err)
      setError(true)
    } finally {
      setIsLoading(false)
    }
  }

  return {
    reportIncidentRequest,
    loadingIncidentReport: isLoading,
    incidentReportSuccess: success,
    incidentReportError: error
  }
}
